module.exports = __webpack_public_path__ + "static/media/filter-concept.0c2deaee.svg";